var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xiaofeipin/%E6%B9%BF%E5%B7%BE%E7%B2%98%E7%9B%96.mp4",
                    'title':"视觉引导湿巾装盖",
                    'lable':"包装好的湿巾经由传送带输送至工业相机下方，通过视觉系统定位、识别、检测，并由机械手定点跟踪、抓取、盖章、涂胶、粘贴至湿巾指定位置，自动化工序完成",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80片/min"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        }
                    ]
                }
            ]
        },
        {
            'name':"并联机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xiaofeipin/%E9%A6%99%E6%B0%B4%E7%93%B6%E7%9B%96%E5%88%86%E6%8B%A3%E5%85%A5%E6%89%98%E5%8D%95%E5%85%83.mp4",
                    'title':"香水瓶盖分拣入托单元",
                    'lable':"注塑机中输出的香水瓶盖经传送带输送至工业相机下方，通过视觉系统定位、识别、检测瓶盖并由机械手定点跟踪抓取、摆放至白色托盘中，摆满后由人工搬走，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80个/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期13个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"注塑机输出"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"相机识别"
                        },
                        {
                            'icon':"/static/case/zqwl.png",
                            'title':"机器人抓取摆盘"
                        },
                        {
                            'icon':"/static/case/rgzy.png",
                            'title':"人工转运"
                        },

                    ]
                },
                {
                   'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xiaofeipin/%E6%B4%97%E5%8F%91%E6%B0%B4%E7%A9%BA%E7%93%B6%E5%88%86%E6%8B%A3%E5%85%A5%E7%BD%90%E8%A3%85%E6%9C%BA%E5%8D%95%E5%85%83%20.mp4",
                    'title':"洗发水空瓶分拣入罐装机单元",
                    'lable':"散乱的洗发水空瓶经传送带输送至工业相机下方，通过视觉系统定位、识别、检测空瓶并由机械手定点跟踪抓取、摆放至料仓中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60个/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转精度±0.1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll-1.png",
                            'title':"理料机上料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"相机识别"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取入料仓"
                        },
                        {
                            'icon':"/static/case/bz.png",
                            'title':"自动灌装"
                        },

                    ]
                },
                {
                   'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xiaofeipin/%E6%B4%97%E6%B4%81%E7%B2%BE%E7%93%B6%E5%88%86%E6%8B%A3%E5%85%A5%E6%A7%BD%E5%8D%95%E5%85%83%20.mp4",
                    'title':"洗洁精瓶分拣入槽单元",
                    'lable':"散乱的洗衣液经传送带输送至工业相机下方，通过视觉系统定位、识别、检测洗衣液正反面并由机械手定点跟踪抓取、按统一正面形态摆放至料仓中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60个/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±1mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转精度±1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期11个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll-1.png",
                            'title':"理料机上料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"相机识别"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取入料仓"
                        },
                        {
                            'icon':"/static/case/bz.png",
                            'title':"自动灌装"
                        },

                    ]
                }
                ,



                {
                   'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xiaofeipin/%E5%8C%96%E5%A6%86%E5%93%81%E7%93%B6%E5%AD%90%E5%88%86%E6%8B%A3%E5%85%A5%E6%A7%BD%20%20.mp4",
                    'title':"化妆品瓶子分拣入槽",
                    'lable':"散乱化妆品瓶子经传送带输送至工业相机下方，通过视觉系统定位、识别、检测瓶子正反面并由机械手定点跟踪、翻转抓取、按统一正面形态摆放至料仓中，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60个/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±1mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转精度±1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll-1.png",
                            'title':"理料机上料"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"相机识别"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取入料仓"
                        },
                        {
                            'icon':"/static/case/bz.png",
                            'title':"自动灌装"
                        },

                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xiaofeipin/%E6%B9%BF%E5%B7%BE%E7%B2%98%E7%9B%96.mp4",
                     'title':"湿巾装盖",
                     'lable':"包装好的湿巾经由传送带输送至工业相机下方，通过视觉系统定位、识别、检测，并由机械手定点跟踪、抓取、盖章、涂胶、粘贴至湿巾指定位置，自动化工序完成。",
                     'list':[
                         {
                             'icon':"/static/case/sd.png",
                             'title':"速度80片/min/台"
                         },
                         {
                             'icon':"/static/case/jd.png",
                             'title':"精度±0.5mm"
                         },
                         {
                             'icon':"/static/case/xzjd.png",
                             'title':"旋转精度±0.5°"
                         }
                         ,
                         {
                             'icon':"/static/case/rg.png",
                             'title':"单台去人工2人"
                         }
                         ,
                         {
                             'icon':"/static/case/ts.png",
                             'title':"效率提升100%"
                         }
                         ,
                         {
                             'icon':"/static/case/tzhbzq.png",
                             'title':"投资回报周期10个月"
                         }
                     ],
                     'process':[
                         {
                             'icon':"/static/case/ll-1.png",
                             'title':"包装机出料"
                         },
                         {
                             'icon':"/static/case/sjdw.png",
                             'title':"相机识别"
                         },
                         {
                             'icon':"/static/case/tj.png",
                             'title':"机器人抓盖并涂胶"
                         },
                         {
                             'icon':"/static/case/zg.png",
                             'title':"追踪粘盖"
                         },
                         {
                            'icon':"/static/case/fz.png",
                            'title':"装箱"
                        },
 
                     ]
                 }
            ]
        }
    ],
    name:"消费品",
    title:"solutions",
    subtitle:"消费品行业应用案例",
    subinfo:"我们的应用案例包括为消费品行业提供搬运装箱、上下料、包装、视觉识别等服务，助力轻工业产业升级。",
}

export default {
    industryInfo
  };


// WEBPACK FOOTER //
// ./src/data/industryInfo/2.js